import React from "react"
import ForBusiness from "../templates/pages/dlabiznesu";

export default () => <ForBusiness isEn={false} />
